import styled from '@emotion/styled';
import { Popover } from '@mui/material';

const SelectorPopover = styled(Popover)({
  maxHeight: 500,
});

export default SelectorPopover;
